import { render } from "./CategoriesTerminal.vue?vue&type=template&id=0a639352&scoped=true"
import script from "./CategoriesTerminal.vue?vue&type=script&lang=js"
export * from "./CategoriesTerminal.vue?vue&type=script&lang=js"

import "./CategoriesTerminal.vue?vue&type=style&index=0&id=0a639352&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a639352"]])

export default __exports__